import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';
import ExternalLink from './external-link';

const submitCaseUrl = 'https://help.avalara.com/Directory/Contact_Avalara/Submit_a_Case';

const ErrorBoundary = () => (
  <Fragment>
    <h2>{"It's not you, it's us"}</h2>
    <p>{"We're having a connection problem.  Wait a few minutes and try again."}</p>
    <p>
      {'If the problem persists, contact '}
      <ExternalLink href={submitCaseUrl}>{t('client.general.avalara-support')}</ExternalLink>
    </p>
  </Fragment>
);

export default ErrorBoundary;
